<template>
  <div class="uiLoader-Box">
    <div class="loader-wrapper">
      <div class="loader"></div>
      <div class="loader-text">
        .. loading ..
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style type="scss">
  .loader-wrapper {
    position: relative;
    text-align: center;
    padding: 5px
  }
  .loader {
    /* border: 16px solid #f3f3f3; */
    border: 10px solid rgba(0,0,0,.07);
    border-top: 10px solid rgba(0,0,0,.23);
    border-bottom: 10px solid rgba(0,0,0,.23);
    border-radius: 50%;
    width: 130px;
    height: 130px;
    animation: spin 2s linear infinite;
    margin: 100px auto
  }
  .loader-text {
    display: block;
    position: absolute;
    line-height: 24px;
    width: 200px;
    text-align: center;
    top:50%; margin-top: -12px;
    left: 50%; margin-left: -100px;
  }
  .collectionEmpty, .collectionError { text-align: center; }
  .stateIcon {
    line-height: 100px;
    font-size: 150px;
    color: #ccc;
    &.red { color: #c00; }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>
